import React from 'react';
import ImprimirIngresos from '../../../components/insumos/ingresos/ImprimirIngresos';

const ImprimirIngresosPage: React.FC = () => {
  return (
    <div style={{ padding: '20px' , textAlign: 'center' , alignItems: 'center', justifyContent: 'center'}}>
        <h2>Comprobante Ingreso</h2>
        <ImprimirIngresos />
    </div>
  );
};

export default ImprimirIngresosPage;